import React, { useRef, useState } from 'react'
import useIntersection from 'hooks/useIntersection'
import styled from 'styled-components'

interface ImageRendererProps extends Record<string, any> {
  alt?: string
  url: string
  thumb?: string
}

const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;

  .image {
    opacity: 0;

    &.thumb {
      opacity: 1;
      filter: blur(20px);
      transition: opacity 1s ease-out;
      position: absolute;
      width: 100%;
      height: 100%;

      &.isLoaded {
        opacity: 0;
      }
    }

    &.isLoaded {
      transition: opacity 0.5s ease-out;
      opacity: 1;
    }
  }
`

/**
 * use ImageRenderer from centraui lib
 * @deprecated
 */
const ImageRenderer = (props: ImageRendererProps) => {
  const { url, thumb, ...rest } = props
  const [isLoaded, setIsLoaded] = useState(false)
  const [isLoadedThumb, setIsLoadedThumb] = useState(false)
  const [isInView, setIsInView] = useState(false)
  const imgRef = useRef<HTMLDivElement>(null)
  useIntersection(imgRef, () => {
    setIsInView(true)
  })

  return (
    <Wrapper className="progressive-image" ref={imgRef}>
      {isInView && (
        <>
          {thumb && (
            <img
              {...rest}
              className={`image thumb ${!!isLoaded ? 'isLoaded' : ''} ${rest.className ? rest.className : ''}`}
              style={{
                visibility: isLoadedThumb ? 'visible' : 'hidden',
              }}
              src={thumb}
              onLoad={() => setIsLoadedThumb(true)}
            />
          )}
          <img
            {...rest}
            className={`image ${!!isLoaded ? 'isLoaded' : ''} ${rest.className ? rest.className : ''}`}
            src={url}
            onLoad={() => setIsLoaded(true)}
          />
        </>
      )}
    </Wrapper>
  )
}

export default ImageRenderer
